export const ValidatorHelper = {
    AFMValidator: {
        IsValidAfm(afmValue) {
            return /^\d{9}$/.test(afmValue || '');
        },
        OnUpdateInputValueValidation(evt) {
            let length = (evt.target.value).length;
            if (length > 9) {
                evt.target.value = evt.target.value.substring(0, 9);
            }
        }
    },
    // LengthValidator(length, value) : {
    //     return (/^\d{length}$/.test(value))
    // }
}

export default ValidatorHelper;